export default "__VITE_ASSET__CquHPhoM__"